import DBConfigService from './DBConfigService';

const ID_TOKEN_KEY = "at" as string;  // Maps to user.at
const ID_RTOKEN_KEY = "rt" as string; // Maps to user.rt
const USER_ID = "id" as string;       // Maps to user.id
const DEVICE_ID = "di" as string;     // Maps to user.di

/**
 * Get current logged-in user from IndexedDB
 */
async function getCurrentUser(): Promise<any> {
  const users = await DBConfigService.getalluserfromstorage();
  // Find the user with kl=true (keep logged in)
  return users.find((u: any) => u.kl === true) || null;
}

/**
 * Update user field in IndexedDB
 */
async function updateUserField(field: string, value: any): Promise<void> {
  const user = await getCurrentUser();
  if (user) {
    user[field] = value;
    await DBConfigService.insertnewuser(user);
  }
}

/**
 * `at` und `rt` liegen in IndexedDB verschluesselt als `{v, iv, data}`-Objekt und
 * werden beim Lesen nur entschluesselt, wenn der CryptoService bereit ist
 * (DBConfigService.getalluserfromstorage). Wer hier ein Objekt zurueckbekaeme,
 * schickte es als `Bearer [object Object]` an den Server — genau die Falle, die
 * ChatDatabaseService.getStudioToken und `asJwt` in chat.server.ts schon
 * abfangen. Nur ein nicht leerer Klartext-String ist ein brauchbares JWT.
 */
const asJwt = (value: unknown): string | null =>
  typeof value === "string" && value ? value : null;

/**
 * @description get token from IndexedDB user table
 */
export const getToken = async (): Promise<string | null> => {
  const user = await getCurrentUser();
  return user ? asJwt(user.at) : null;
};

export const getRefreshToken = async (): Promise<string | null> => {
  const user = await getCurrentUser();
  return user ? asJwt(user.rt) : null;
};

export const getUserId = async (): Promise<string | null> => {
  const user = await getCurrentUser();
  return user ? user.id : null;
};

export const getDeviceId = async (): Promise<string | null> => {
  const user = await getCurrentUser();
  return user ? user.di : null;
};

/**
 * @description save token to IndexedDB user table
 * @param token: string
 */
export const saveToken = async (token: string): Promise<void> => {
  await updateUserField('at', token);
};

export const saveRefreshToken = async (token: string): Promise<void> => {
  await updateUserField('rt', token);
};

export const saveUserId = async (id: string): Promise<void> => {
  await updateUserField('id', id);
};

export const saveDeviceId = async (id: string): Promise<void> => {
  await updateUserField('di', id);
};

/**
 * @description destroy token from IndexedDB user table
 */
export const destroyToken = async (): Promise<void> => {
  await updateUserField('at', '');
  await updateUserField('rt', '');
};

export default { getToken, getRefreshToken, getUserId, getDeviceId, saveToken, saveRefreshToken, saveUserId, saveDeviceId, destroyToken };
